export const mbCmsComponents = {
  shared: {
    viewDetails: 'View details',
    relatedProducts: 'Related products',
    contactBoxTitle: 'Need help? We’re here for you',
    contactBoxTitleUS: 'Need help? We’re here for you',
    contactBoxCustomerService: 'Customer Service',
    contactBoxCustomerServiceUS: 'Contact customer service team',
    contactBoxAccountManagement: 'Contact account management team',
    contactBoxQuestionsAroundQuotes: 'Questions around quotes?',
    contactBoxTroubleWithPurchasing: 'Trouble with purchasing?',
    contactBoxRegistrationAndPurchases: 'For registration and purchases:',
    contactBoxFullOrdersTitle: 'Orders',
    contactBoxFullTechnicalTitle: 'Technical support',
    contactUs: 'Contact Us',
    email: 'E-mail',
    phone: 'Phone',
    fax: 'Fax',
    web: 'Web',
    ordersPhone: 'Phone',
    ordersFax: 'Fax',
    ordersEmail: 'E-mail',
    technicalPhone: 'Miltenyi support phone',
    technicalSupportPhoneAvailability: 'Phone availability',
    technicalMail: 'E-mail',
    technicalSupportEmail: 'Miltenyi support e-mail',
    miltenyiSupportPhone: 'Miltenyi support phone',
    phoneAvailability: 'Phone availability',
    miltenyiSupportEmail: 'Miltenyi support e-mail',
    chatAvailability: 'Chat availability',
    technicalSupportChatAvailability: 'Chat availability',
    macsHandbooks: 'MACS Handbook:',
    relatedContent: 'Related content:',
    contactBoxRequests: 'For requests:',
    playVideo: 'Play video',
    video: 'Video',
    relatedVideos: 'Related videos',
    footerCopyright: 'Copyright © {{year}} Miltenyi Biotec and/or its affiliates. All rights reserved.',
    readMore: 'Read more …',
    downloadPDF: 'Download PDF',
    relatedPDFs: 'Related PDFs',
    campusModalImageTags: 'Miltenyi University',
    headerIntroTextForProtocolLinkText: 'Download application',
    timeline: 'Timeline',
    viewTimeline: 'View timeline',
    arrowLeft: 'arrow left',
    arrowRight: 'arrow right',
    tableOfContent: 'Table of content',
    menu: 'Menu',
    close: 'Close',
    viewChapter: 'View Chapter',
    selectTissueType: 'Select a tissue type',
    selectedAntibodies: 'Selected antibodies',
    tapToToggleOnOff: '(tap to toggle on and off)',
    selectAnyAntibodyToStart: 'Select any antibody to start',
    chooseAntibodies: 'Choose antibodies',
    max6Simultaneously: '(max. 6 simultaneously)',
    europe: 'Europe',
    america: 'America',
    apac: 'Asia pacific',
    locations: 'locations',
    backToWorldOverview: 'Back to world overview',
    worldLocationsMap: 'Locations Map - World',
    europeLocationsMap: 'Locations Map - Europe',
    americaLocationsMap: 'Locations Map - North America',
    apacLocationsMap: 'Locations Map - Asian Pacific',
    allLocationsFilter: 'All Locations',
    factoryLocationsFilter: 'Cell factory',
    universityLocationsFilter: 'Training center',
    regionsWithOffices: 'Regions with local offices',
    regionsWithDistributors: 'Regions with distributors',
    goToDistributor: 'Go to distributor overview',
    forImmediateTechnicalSupport: 'For immediate technical support, use our live chat.',
    technicalSupportText: 'To talk to a technical support representative via our live chat option, please visit our ',
    localDistribution: 'Local distribution',
    localDistributionText: 'Are you looking for your local distribution contact? Check out our ',
    contact: 'Contact',
    iqViewTooltipProjectbrowser: 'Open and organize the datasets you have generated.',
    iqViewTooltipProperties: 'This toolbox allows you to change, for example, size and location of gates and annotations in the image or graph.',
    iqViewTooltipTools: 'Create annotations and gates to highlight or select the cells you want to analyze.',
    iqViewTooltipHistogram: 'Adjust the contrast and highlight the range of the channel to display your marker of interest optimally.',
    iqViewTooltipSegmentation: 'Define nuclei and cell boundaries, based on which the software will measure all the features.',
    iqViewTooltipFeatureplot: 'Display the interactive plot you are working with. Can be from scatter plot to heatmap.',
    iqViewTooltipFeaturetable: 'Display the raw values gathered after segmentation. You can view all the features you have analyzed. Additionally, you are able to choose which data you want to present and export.',
    iqViewTooltipSequencer: 'Use this tool to create images and movies that you can include in your publications, for example. After adding images with the desired markers, gates, and zoom settings to the sequencer, you can either export all images separately or as a movie.',
    iqViewTooltipCellselectionoverlays: 'View a list of all the gates and annotations you have created and choose which ones you want to make visible on the image.',
    iqViewTooltipBiomarkerreference: 'Benefit from this integrated biomarker database that you can modify to create your own repository of information about the markers you use and how you classify them.',
    iqViewFeatureTable: 'Feature table',
    iqViewFeaturePlot: 'Feature table',
    iqViewImageView: 'Image view - blue',
    iqViewInfoblue: 'Cell nuclei (blue)',
    iqViewInfocyan: 'Gated tumor cells (cyan)',
    iqViewInfoyellow: 'Gated T cells (yellow)',
    iqViewInfored: 'CD3<sup>+</sup> cells (red)',
    iqViewInfogreen: 'Cytokeratin 5<sup>+</sup> cells (green)',
    iqViewIntro: 'Click and start interacting',
    iqViewBgImageTitle: 'MACS iQ tissue software',
    resources: 'Resources',
    selectedReferences: 'Selected references',
    hotline: 'Hotline',
    viewAllUserManuals: 'View all user manuals',
    relatedProductsAndFamiliesHeadline: 'Related products',
    relatedProductsAndFamiliesProductsAvailable: 'products available',
    search: 'Search:',
    privacySettings: 'Privacy Settings',
    more: 'more',
    contentOverview: 'Content Overview',
    tokenExpiredHeadline: 'The link you are trying to reach has expired.',
    tokenExpiredText: '<br>Please use a link from a recent newsletter to access your Preference Center settings.<br>If you have further' +
      ' questions, please contact <a href="mailto:preferencecenter@miltenyi.com" data-cy="email-link" class="cms-email-link" title="">preferencecenter@miltenyi.com</a>.',
    contentListEmptyResultsMessage: 'Sorry, we couldn’t find a match for your search term.',
    contentListEmptyResultsLineOne: 'Please check your spelling and try again.',
    protocol: 'Protocol',
    faqLinkDescription: 'Find answers in our FAQs',
  },

  videoLibrary: {
    header: 'Miltenyi Biotec\'s video library',
    searchPlaceholder: 'Enter a search term',
    channelSelectPlaceholder: 'Select a channel',
    introductionHeadline: 'Technology videos, webinars, and helpful tutorials in biomedical research',
    introductionText: 'Explore our extensive video library and find out about a wide range of specific applications and technologies for cell and gene therapy',
    videoSearchQueryResultText: 'Search results for "{{ query }}": <strong>{{ count }} videos</strong>',
    videoSearchQueryAndChannelResultText: 'Search results for “{{ query }}” in “{{ channel }}”: <strong>{{ count }} videos</strong>',
    videoSearchChannelResultText: '{{ channel }}: <strong>{{ count }} videos</strong>',
    minCharCountNotReached: 'No search results yet. Please enter at least {{ countString }} characters.',
    showAll: 'show all'
  },

  iqView: {
    tooltipProjectbrowser: 'Open and organize the datasets you have generated.',
    tooltipProperties: 'This toolbox allows you to change, for example, size and location of gates and annotations in the image or graph.',
    tooltipTools: 'Create annotations and gates to highlight or select the cells you want to analyze.',
    tooltipHistogram: 'Adjust the contrast and highlight the range of the channel to display your marker of interest optimally.',
    tooltipSegmentation: 'Define nuclei and cell boundaries, based on which the software will measure all the features.',
    tooltipFeatureplot: 'Display the interactive plot you are working with. Can be from scatter plot to heatmap.',
    tooltipFeaturetable: 'Display the raw values gathered after segmentation. You can view all the features you have analyzed. Additionally, you are able to choose which data you want to present and export.',
    tooltipSequencer: 'Use this tool to create images and movies that you can include in your publications, for example. After adding images with the desired markers, gates, and zoom settings to the sequencer, you can either export all images separately or as a movie.',
    tooltipCellselectionoverlays: 'View a list of all the gates and annotations you have created and choose which ones you want to make visible on the image.',
    tooltipBiomarkerreference: 'Benefit from this integrated biomarker database that you can modify to create your own repository of information about the markers you use and how you classify them.',
    featureTable: 'Feature table',
    featurePlot: 'Feature table',
    imageView: 'Image view - blue',
    infoblue: 'Cell nuclei (blue)',
    infocyan: 'Gated tumor cells (cyan)',
    infoyellow: 'Gated T cells (yellow)',
    infored: 'CD3<sup>+</sup> cells (red)',
    infogreen: 'Cytokeratin 5<sup>+</sup> cells (green)',
    intro: 'Click and start interacting',
    bgImageTitle: 'MACS iQ tissue software',
  },

  jobSearch: {
    workTime: 'Working time',
    experience: 'Experience',
    company: 'Company',
    search: 'Search',
    sideBarJobCategory: 'Job Category:',
    sideBarWorkTime: 'Working time:',
    sideBarLocation: 'Location:',
    sideBarContact: 'Contact:',
    allJobCategories: 'All job categories',
    applyButtonEventAction: 'Click Apply for the job',
    applyButtonEventCategory: 'Careers',
    applyButtonText: 'Apply now',
    share: 'Share',
    privacyLinkText: 'Miltenyi\'s Privacy Statement for candidates',
    resultHeadline: '<h2>All open positions ({{count}})</h2>',
    shareMessageDesktop: 'Link copied!'
  },

  cmsList: {
    searchResultHeader: '<strong>{{ count }}</strong> results for "{{ query }}"',
    searchResultHeaderEmpty: '<strong>{{ count }}</strong> results',
    keywords: 'Keywords',
    showMore: 'Show more...',
    showLess: 'Show less...',
    showMoreFilters: 'Show more filters',
    showLessFilters: 'Show less filters',
    and: 'AND',
    or: 'OR',
    filteredBy: 'Filtered by:',
    emptyResultTitle: 'Sorry, we couldn’t find a match for your search term.',
    emptyResultLineOne: 'Please check your spelling and try again.',
    search: 'Search:'
  },

  ucBlockedContent: {
    chatConsentModalHeadline: 'Open chat',
    consentNeeded: 'We need your consent',
    acceptThirdParty: 'Please accept the data transfer to the 3rd-party service {{ ucService }} to load this content',
    accept: 'Accept and {{ buttonText }}',
    moreInfo: 'More info in your',
    consentForLinks: 'To play the video we need your consent. Please click here to manage your privacy settings.',
    privacySettings: 'Privacy Settings'
  }
}
